/**
 * Settings page — localization manifest.
 */
export const settingsManifest: readonly string[] = [
  "common.settings",
  "common.save",
  "common.cancel",
  "common.loading",
  "nav.settings",
  "auth.email",
  "auth.password",
  "common.name",
] as const;
